import { render, staticRenderFns } from "./ValidConfig.vue?vue&type=template&id=2976b737"
import script from "./ValidConfig.vue?vue&type=script&lang=js"
export * from "./ValidConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports